import { render, staticRenderFns } from "./OtherReviewTags.vue?vue&type=template&id=221335ba"
import script from "./OtherReviewTags.vue?vue&type=script&lang=js"
export * from "./OtherReviewTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports